import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customerServices } from '../services/customer.service';
import { toast } from 'react-hot-toast';

export const useUpdateCustomerStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: customerServices.updateCustomerStatus,
    onSuccess: (data, variables) => {
      toast.success('Customer status updated successfully');
      queryClient.invalidateQueries({ queryKey: ['customer', variables.customerId] });
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      queryClient.invalidateQueries({ queryKey: ['customerStats'] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update customer status');
    },
  });
};
